import styles from './ChartTooltip.module.css';

export interface TooltipEntry {
  name?: string | number;
  value?: number | string;
  color?: string;
  dataKey?: string | number;
}

export interface ChartTooltipProps {
  active?: boolean;
  label?: string | number;
  payload?: TooltipEntry[];
  /** Formats a series value; defaults to a plain string. */
  format?: (value: number | string, key: string) => string;
  /** Renames a series for display. */
  nameOf?: (key: string) => string;
}

/**
 * One tooltip for every chart in the app, so the hover layer reads the same
 * everywhere. Recharts' default tooltip ignores the design tokens.
 */
export function ChartTooltip({ active, label, payload, format, nameOf }: ChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className={styles.tooltip}>
      {label !== undefined ? <div className={styles.label}>{label}</div> : null}
      {payload.map((entry) => {
        const key = String(entry.dataKey ?? entry.name ?? '');
        const value = entry.value ?? '';
        return (
          <div className={styles.row} key={key}>
            <span className={styles.swatch} style={{ background: entry.color }} />
            <span>{nameOf ? nameOf(key) : key}</span>
            <span className={styles.value}>{format ? format(value, key) : String(value)}</span>
          </div>
        );
      })}
    </div>
  );
}
